export default __webpack_public_path__ + "static/banner.light-0a2c21d74cba0a9a2ce3636dfc436cadb16cb3de83b1936e60911132b3f2e3e6.png";